module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Blog List"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Blog List Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "blog-list-nest"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "https://source.unsplash.com/collection/190727/1600x900",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-content"
  }, [_c('h2', [_vm._v("Article Heading")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline blog-devin-tag"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-pencil"
  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-rss-alt"
  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pull-left"
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-nest"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "https://source.unsplash.com/category/buildings/1024x764",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-content"
  }, [_c('h2', [_vm._v("Godzilla")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline blog-devin-tag"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-pencil"
  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-rss-alt"
  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pull-left"
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-nest"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('blockquote', [_c('p', [_vm._v("\"How can we win when fools can be king\"")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Mattew Bellamy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-content"
  }, [_c('h2', [_vm._v("Muse")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline blog-devin-tag"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-pencil"
  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-rss-alt"
  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pull-left"
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-nest"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "https://source.unsplash.com/category/people/1024x764",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-content"
  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline blog-devin-tag"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-pencil"
  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-rss-alt"
  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis pharetra varius quam sit amet vulputate. Quisque mauris augue, molestie tincidunt condimentum vitae, gravida a libero. Aenean sit amet felis dolor, in sagittis nisi. Sed ac orci quis tortor imperdiet venenatis. Duis elementum auctor accumsan. Aliquam in felis sit amet augue.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pull-left"
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info pull-right"
  }, [_vm._v("Read More")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "pager success"
  }, [_c('li', {
    staticClass: "previous"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("← Older")])]), _vm._v(" "), _c('li', {
    staticClass: "next disabled"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Newer →")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('img', {
    staticClass: "media-object img-circle blog-profile",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/men/10.jpg"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Dave Mattew")]), _vm._v(" "), _c('p', {
    staticClass: "tex-center social-blog-profile"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-facebook-circled"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tweet-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-twitter-circled"
  })]), _vm._v(" "), _c('a', {
    staticClass: "gplus-textcolor",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-instagrem"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "social-follower text-center"
  }, [_vm._v("A graphics designer, a web developer, a boyfriend, a friend, a son")])])]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("JOIN NEWSLETTER")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Sign up for our daily Newslatter")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-full-width-left"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign up")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_vm._v("POPULAR POST")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/17.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("88 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/21.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("90 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/20.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("42 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/19.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("111 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/18.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("123 Views")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_vm._v("TAG")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Fleet")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Computer")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Web Design")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Movie")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d74bdc0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/BlogList.vue
// module id = 1019
// module chunks = 2